import config from '../config';
import selectedEnvironment from '../env';

const API_URL = `${config[selectedEnvironment].API_URL}`;
const BASE = `${API_URL}/ClarificationDocuments`;

const authHeaders = (token) => ({
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
});

export const MoveToClarification = async (payload, token) => {
    const response = await fetch(`${BASE}/Move`, {
        method: 'POST',
        headers: authHeaders(token),
        body: JSON.stringify(payload),
    });
    return response;
};

export const RestoreFromClarification = async (payload, token) => {
    const response = await fetch(`${BASE}/Restore`, {
        method: 'POST',
        headers: authHeaders(token),
        body: JSON.stringify(payload),
    });
    return response;
};

export const RejectClarificationDocument = async (payload, token) => {
    const response = await fetch(`${BASE}/Reject`, {
        method: 'POST',
        headers: authHeaders(token),
        body: JSON.stringify(payload),
    });
    return response;
};

export const GetClarificationDocumentsByDateRange = async (payload, token) => {
    const response = await fetch(`${BASE}/byDateRange`, {
        method: 'POST',
        headers: authHeaders(token),
        body: JSON.stringify(payload),
    });
    return response;
};

export const UpdateClarificationDocument = async (id, payload, token) => {
    const response = await fetch(`${BASE}/${id}`, {
        method: 'PUT',
        headers: authHeaders(token),
        body: JSON.stringify(payload),
    });
    return response;
};

export const AttachClarificationMessages = async (payload, token) => {
    const response = await fetch(`${BASE}/AttachMessages`, {
        method: 'POST',
        headers: authHeaders(token),
        body: JSON.stringify(payload),
    });
    return response;
};

export const GetClarificationMessages = async (documentType, documentId, caseId, token) => {
    const qs = new URLSearchParams({ caseId });
    const response = await fetch(`${BASE}/${documentType}/${documentId}/Messages?${qs.toString()}`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response;
};

export const DeleteClarificationMessages = async (documentType, documentId, caseId, token, messageIds = []) => {
    const qs = new URLSearchParams({ caseId });
    (messageIds || []).forEach((id) => {
        if (id) qs.append('messageIds', id);
    });
    const response = await fetch(`${BASE}/${documentType}/${documentId}/Messages?${qs.toString()}`, {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response;
};

export const DeleteClarificationDocument = async (id, caseId, token, accountantId) => {
    const qs = new URLSearchParams({ caseId });
    if (accountantId) qs.set('accountantId', accountantId);
    const response = await fetch(`${BASE}/${id}?${qs.toString()}`, {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response;
};

const ClarificationDocumentService = {
    MoveToClarification,
    RestoreFromClarification,
    RejectClarificationDocument,
    GetClarificationDocumentsByDateRange,
    UpdateClarificationDocument,
    AttachClarificationMessages,
    GetClarificationMessages,
    DeleteClarificationMessages,
    DeleteClarificationDocument,
};

export default ClarificationDocumentService;
